<template>
    <v-flex xs12 pb-5>
        <a href="/dashboard">Личный кабинет</a>
        <span style="color: #00ba57">/</span>
        <a class="pt-5 pb-4" href="/b2b-services">Сервисы</a>
    </v-flex>
</template>

<script>
export default {
    name: "ServicesBreadcrumbs"
}
</script>

<style scoped>
 a {
     font-family: 'SFPro';
     font-size: 16px;
     color: #00ba57;
 }
</style>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesBreadcrumbs.vue